import React from 'react';
import useStoreTopCashback from '../../../../hooks/useStoreTopCashback';
import StoreCard from '../StoreCard/StoreCard';
import * as S from '../../Styled';
import AlphabetFilter from '../Alphabet/Alphabet';

const TopCashbackStores = ({selectedLetter, setSelectedLetter }) => {
    const { topCashbackStores, loadingTopCashbackStores, errorTopCashbackStores } = useStoreTopCashback();

    const cashbackStores = topCashbackStores.filter(store => store.cashbackOn);

    const availableLetters = cashbackStores?.length
        ? [...new Set(cashbackStores.map(store => store.name[0].toUpperCase()))]
        : [];

    const filteredStores = cashbackStores.filter(store => {
        if (selectedLetter === 'Todos') return true;
        return store.name.toUpperCase().startsWith(selectedLetter);
    });


    if (filteredStores.length === 0) {
        return <p style={{ textAlign: 'center', marginTop: '2rem' }}>Nenhuma loja encontrada para a letra "{selectedLetter}"</p>;
    }

    return (
        <>
            <AlphabetFilter
                selectedLetter={selectedLetter}
                setSelectedLetter={setSelectedLetter}
                availableLetters={availableLetters}
            />
            <S.StoreBox>
                <S.StoreGrid>
                    {filteredStores.map(store => (
                    <S.StoreCardWrapper key={store.id}>
                        <StoreCard store={store} />
                    </S.StoreCardWrapper>
                    ))}
                </S.StoreGrid>
            </S.StoreBox>
        </>
    );
};

export default TopCashbackStores;
